import React from "react";
import FindingResourcesCountKPI, {
  type FindingResourcesCountKPIProps,
} from "./FindingResourcesCountKPI";

type CriticalFindingResourcesKPIProps = Pick<
  FindingResourcesCountKPIProps,
  "selectedScope" | "filterToExecute" | "scopeToExecute" | "setIsReadyToExport"
>;

const CriticalFindingResourcesKPI: React.FC<
  CriticalFindingResourcesKPIProps
> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  setIsReadyToExport = null,
}) => {
  const filterFieldsToOverride = JSON?.stringify({
    value: ["3"],
    field: "remediation_item.severity",
    condition: "in",
  });

  return (
    <FindingResourcesCountKPI
      scopeToExecute={scopeToExecute}
      selectedScope={selectedScope}
      filterToExecute={filterToExecute}
      filterFieldsToOverride={filterFieldsToOverride}
      severity={3}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default CriticalFindingResourcesKPI;
